var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconWebHomeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick_empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .homeline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "homeline",
    d: "M19.06,42.69v-9.29c0-3.54,2.89-6.43,6.43-6.43h0c3.54,0,6.43,2.89,6.43,6.43v9.29c0,1.15.93,2.08,2.08,2.08h6.61c2.3,0,4.16-1.86,4.16-4.16v-19.32c0-1.36-.63-2.63-1.69-3.44l-15.7-10.97c-1.43-1-3.34-1-4.77,0l-15.7,10.97c-1.07.81-1.69,2.08-1.69,3.44v19.21c0,2.36,1.86,4.27,4.16,4.27h7.6c1.15,0,2.08-.93,2.08-2.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconWebHomeLine);
export default __webpack_public_path__ + "static/media/cloud_icon_web_home_line.9fa65445692bf82eb88bf037df52ff68.svg";
export { ForwardRef as ReactComponent };